// @mui
import { ListItemButton, Paper } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// utils
//
import { NavItemDesktopProps } from '../types';

// ----------------------------------------------------------------------

type ListItemProps = Omit<NavItemDesktopProps, 'item'>;

export const ListItem = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    prop !== 'active' && prop !== 'open' && prop !== 'isOffset' && prop !== 'subItem',
})<ListItemProps>(({ active, open, isOffset, subItem, theme }) => ({
  ...theme.typography.subtitle1,
  padding: 0,
  overflow: 'hidden',
  height: '100%',
  color: theme.palette.text.primary,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover': {
    opacity: 0.48,
    backgroundColor: 'transparent',
  },
  ...(subItem && {
    ...theme.typography.body1,
    color: theme.palette.text.primary,
  }),
  ...(isOffset && {
    color: theme.palette.text.primary,
  }),
  ...(active && {
    color: theme.palette.primary.main,
  }),
  ...(active &&
    subItem && {
      ...theme.typography.subtitle2,
      color: theme.palette.text.primary,
      '&::before': {
        color: theme.palette.primary.main,
      },
    }),
  ...(open && {
    color: theme.palette.primary.main,
  }),
}));

// ----------------------------------------------------------------------

export const StyledMenu = styled(Paper)(({ theme }) => ({
  width: '250px',
  display: 'flex',
  position: 'absolute', // Mudança para posição absoluta
  top: '100%', // Posicionar o Paper abaixo do menu
  left: 0, // Posicionar o Paper à esquerda
  transform: 'translateX(-60%)', // Centralizar o Paper horizontalmente
  textAlign: 'justify',
  padding: theme.spacing(3, 3), // Ajuste de padding
  boxShadow: theme.customShadows.dialog,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  border: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
  zIndex: 9999, // Defina um valor alto para o z-index
}));
// ----------------------------------------------------------------------
